<section>
  <img alt="logo da noclaf" src="../../../../assets/images/logo.png">
  <h5> Carregando... </h5>
</section>